module.exports = __webpack_public_path__ + "static/media/shape.f9fe507a.svg";